import { type SearchListingsOptions, type WithRequired } from '@pkgs/api/types';
import { type SearchFilterRequestPropertyTypeSubType } from '@pkgs/api/models';
import { type PropertySubType, type PropertyType, type SearchListingsParams } from '@generated/search-bff';

import { getEntries } from './object';
import { APARTMENT_SUB_TYPES, HOUSE_SUB_TYPES, LAND_SUB_TYPES } from '../constants';

export function mapOptionsToSearchListingsParams(options: SearchListingsOptions): WithRequired<SearchListingsParams, 'offset' | 'limit'> {
  const { language, measurementSystem, currency, page, pageSize, marketCountryCode } = options;
  const _pageSize = pageSize ?? 20;
  return {
    language,
    measurementSystem,
    currency,
    offset: page ? (page - 1) * _pageSize : 0,
    limit: _pageSize,
    ...(marketCountryCode && { marketCountryCode }),
  };
}

export function mapDeprecatedPropertyTypeParams(
  propertyType?: PropertyType[],
  propertySubType?: PropertySubType[],
): SearchFilterRequestPropertyTypeSubType {
  const propertyTypeSubType: SearchFilterRequestPropertyTypeSubType = {};

  if (propertyType && propertyType.length > 0) {
    for (const type of propertyType) {
      if (type === '') continue;
      propertyTypeSubType[type] = [];
    }
  }

  if (propertySubType && propertySubType.length > 0) {
    for (const subType of propertySubType) {
      if (subType === '') continue;
      if (APARTMENT_SUB_TYPES.includes(subType)) {
        propertyTypeSubType.apartment = [...(propertyTypeSubType.apartment ?? []), subType];
      }
      if (HOUSE_SUB_TYPES.includes(subType)) {
        propertyTypeSubType.house = [...(propertyTypeSubType.house ?? []), subType];
      }
      if (LAND_SUB_TYPES.includes(subType)) {
        propertyTypeSubType.land = [...(propertyTypeSubType.land ?? []), subType];
      }
    }
  }
  // if all subtypes are selected, set the property type to empty array which means all subtypes are allowed for that type
  for (const [key, value] of getEntries(propertyTypeSubType)) {
    const subTypesLength =
      key === 'apartment' ? APARTMENT_SUB_TYPES.length : key === 'house' ? HOUSE_SUB_TYPES.length : LAND_SUB_TYPES.length;

    if (value?.length === subTypesLength) {
      propertyTypeSubType[key] = [];
    }
  }
  return propertyTypeSubType;
}
